import React, { useState } from 'react';
import { Download, FileText, Image as ImageIcon, Presentation, Loader2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const ExportMenu = ({ onExport, isExporting }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" disabled={isExporting}>
          {isExporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuLabel>Export Current Slide</DropdownMenuLabel>
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => onExport('current', 'pdf')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>PDF</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('current', 'pptx')}>
            <Presentation className="mr-2 h-4 w-4" />
            <span>PPTX</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('current', 'png')}>
            <ImageIcon className="mr-2 h-4 w-4" />
            <span>PNG Image</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Export All Slides</DropdownMenuLabel>
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => onExport('all', 'pdf')}>
            <FileText className="mr-2 h-4 w-4" />
            <span>PDF Document</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('all', 'pptx')}>
            <Presentation className="mr-2 h-4 w-4" />
            <span>PPTX Presentation</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport('all', 'zip')}>
            <ImageIcon className="mr-2 h-4 w-4" />
            <span>Images (ZIP)</span>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
